// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3JwcO","left":"StickyBox_left__2QR98","right":"StickyBox_right__2iL2x"};